<template>
  <Navbarv2 :informasiDasar="informasiDasar" />
  <div class="">
    <div class="grid grid-cols-1 justify-items-center bg-birulangitmaluku min-h-screen">
      <div class="text-center flex items-center">
        <div>
          <p class="md:text-3xl text-xl font-semibold text-ungu">{{ $t("message.e4001") }}</p>
          <p class="mt-[15px] text-xs text-ungu">{{ $t("message.e4002") }}</p>
          <router-link :to="{ name: 'landingpage' }">
            <button class="bg-blue-maluku text-white mt-5 py-2 px-5 rounded-lg hover:bg-ungu">{{ $t("message.e400btn") }}</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";

import Navbarv2 from "./Navbarv2.vue";
import { getInformasiDasar } from "@/api/LandingPageApi";
import { onMounted } from "@vue/runtime-core";
export default {
  components: {
    Navbarv2,
  },
  setup() {
    const informasiDasar = ref({});

    onMounted(async () => {
      const result = await getInformasiDasar();
      if (result?.data?.data) informasiDasar.value = result.data.data;
    });

    return{informasiDasar}
  },
};
</script>
